/**
 * Created by Alican Köker on 2019-03-20.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {EdisonSoundConfig} from "../../EdisonSoundConfig";

export class EdisonStackedSymbolOverlay extends BaseView {

    private _overlaySpine:PIXI.spine.Spine;
    private _overlaySpineGold:PIXI.spine.Spine;
    private _overlayVisualGold:PIXI.Sprite;
    private _overlayMask:PIXI.Graphics;
    private _m1SpineName:string = "bugsyStacked";
    private _m2SpineName:string = "bettyStacked";
    private _m1AnimName:string = "StackBug";
    private _m2AnimName:string = "StackBett";

    private _m1ImagePathName:string = "M1";
    private _m2ImagePathName:string = "M2";

    private _overlayWidth:number;
    private _overlayHeight:number;
    private _symbol:string = "M1";
    private _reelIndex:number = 0;

    private _m1GoldTransitionAnimName:string = "bugsyStackedWild";
    private _m2GoldTransitionAnimName:string = "bettyStackedWild";

    private _isGold:boolean = false;


    constructor() {
        super();

        this._overlayWidth = EdisonGameConfig.instance.SYMBOL_WIDTH;
        this._overlayHeight = (EdisonGameConfig.instance.SYMBOL_HEIGHT + EdisonGameConfig.instance.SYMBOL_BOTTOM_PADDING) * 3;
    }


    protected initAnimations():void {

    }

    private createGraphics(symbol:string):void {

        let spineName:string = symbol === "M1" ? this._m1SpineName : this._m2SpineName;

        this._overlaySpine = new PIXI.spine.Spine(GameResources.getSpineAsset(spineName));

        spineName = symbol === "M1" ? this._m1GoldTransitionAnimName : this._m2GoldTransitionAnimName;

        this._overlaySpineGold = new PIXI.spine.Spine(GameResources.getSpineAsset(spineName));
        this._overlaySpineGold.visible = false;

        this.removeChild(this._overlaySpine);
        this.addChild(this._overlaySpine);

        let imageNameKey:string = symbol === "M1" ? this._m1ImagePathName : this._m2ImagePathName;
        let imagePath:string = imageNameKey + "/" + imageNameKey + "_Stack";

        this._overlayVisualGold = new PIXI.Sprite(GameResources.getTextures(imagePath + "_Gold")[0]);

        this._overlayMask = new PIXI.Graphics();
        this._overlayMask.beginFill(0x005588, 1);
        this._overlayMask.drawRect(0, 0, this._overlayWidth, this._overlayHeight);
        this._overlayMask.endFill();

        this._overlayMask.position.set(-this._overlayMask.width / 2, -this._overlayMask.height / 2);
        this._overlayVisualGold.position.set(-this._overlayVisualGold.width / 2, -this._overlayVisualGold.height / 2);


        this.addChild(this._overlayMask);
        this.addChild(this._overlayVisualGold);
        this.addChild(this._overlaySpine);
        this.addChild(this._overlaySpineGold);

        this._overlayVisualGold.visible = false;
        this._overlayVisualGold.mask = this._overlayMask;
        this._overlaySpineGold.mask = this._overlayMask;
        this._overlaySpine.mask = this._overlayMask;

        this._isGold = false;
    }


    public playAppearAnimation(symbol:string, reelId:number, restore:boolean = false):void {
        this._symbol = symbol;
        this._reelIndex = reelId;

        this.createGraphics(symbol);

        let animationName:string = symbol === "M1" ? this._m1AnimName : this._m2AnimName;
        this._overlaySpine.state.setAnimation(0, animationName, false);
    }

    public playGoldOverlayAnim():void {
        this._overlaySpineGold.visible = true;
        this._overlaySpineGold.state.setAnimation(0, "transform2wild", false);
        SlotGame.sound.playEffect(EdisonSoundConfig.instance.STACKED_TRANSFORM);
    }

    public playRestore(symbol:string):void {
        this.createGraphics(symbol);
        this._overlayVisualGold.visible = false;
    }

    public playDisappearAnimation():TimelineLite {
        if(!this._overlaySpine)
            return new TimelineLite();

        this.playMaskAnimation();

        let tl:TimelineLite = new TimelineLite();

        const removeSpeed:number = .67;
        const bounceSpeed:number = .1;
        const yBounceDistance:number = this._overlaySpine.position.y - 50;
        const yBounceDistanceGold:number = this._overlayVisualGold.position.y - 50;
        const yDistance:number = this._overlaySpine.position.y + 750;
        const yDistanceGold:number = this._overlayVisualGold.position.y + 750;

        tl.add(() => {
            TweenLite.to(this._overlaySpine, bounceSpeed, {y : yBounceDistance, ease : Linear.easeNone});
            TweenLite.to(this._overlaySpineGold, bounceSpeed, {y : yBounceDistance, ease : Linear.easeNone});
            TweenLite.to(this._overlayVisualGold, bounceSpeed, {y : yBounceDistanceGold, ease : Linear.easeNone});
        });

        tl.add(() => {
            TweenLite.to(this._overlaySpine, removeSpeed, {y : yDistance});
            TweenLite.to(this._overlaySpineGold, removeSpeed, {y : yDistance});
            TweenLite.to(this._overlayVisualGold, removeSpeed, {y : yDistanceGold});
        }, bounceSpeed + .05);

        tl.add(() => {
            this.removeChildren();
        }, 1.5);

        return tl;
    }

    public playMaskAnimation():void {
        this._overlayVisualGold.visible = true;
        this._isGold = true;
    }


    public get reelIndex():number {
        return this._reelIndex;
    }

    public tint():void {
        this._overlaySpine.tint = 0x888888;
    }

    public unTint():void {
        this._overlaySpine.tint = 0xffffff;
    }

}